import { registerEnumType } from 'type-graphql'

export enum ReturnRefundLegStatusEnum {
  Pending = 'Pending',
  Refunded = 'Refunded',
  Failed = 'Failed',
}

registerEnumType(ReturnRefundLegStatusEnum, {
  name: 'ReturnRefundLegStatusEnum',
  description: 'Execution status of an actual-refund leg against a source order payment.',
})
